<template>
  <div class="school_container">
    <div class="school-img img-4"></div>
    <div class="our-school-info-container">
      <div
        class="img-label-container"
        style="position: absolute; bottom: 0; right: 0; left: 0"
      >
        <div class="d-flex justify-content-around">
          <router-link
            v-for="image in images"
            :key="image.id"
            role="link"
            :to="{ name: image.href }"
          >
            <div class="our-school-content" role="link">
              <p class="our-school-title-name mb-2">
                {{ image.text[fontType] }}
              </p>
              <p class="our-school-age-text">{{ image.age[fontType] }}</p>
            </div>
          </router-link>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'PosterSection',

  props: {
    images: {
      type: Array,
      required: true,
    },
    fontType: {
      type: String,
      required: true
    },
  },
}
</script>

<style lang="scss" scoped>
.school_container {
  position: relative;
}

.our_school_div_letter {
  bottom: 0;
  color: white;
  left: 50%;
  transform: translate(-50%, -0%);
  position: absolute;
}

.school-img {
  width: 100%;
  height: 400px;
  background-repeat: no-repeat;
  background-position: center;
  background-size: 100% 100%;
}

.img-4 {
  height: 600px !important;
  background-image: url("@/assets/img/home/our-school/Summer-School.jpg");
}

.img-label-container {
  padding: 10px;
  background-color: #a19e9e80;
}

.our-school-content {
  &:hover {
    cursor: pointer;

    p {
      color: var(--cus-primary) !important;
    }
  }
}

.our-school-title-name {
  transition: color !important;
  text-transform: uppercase;
  color: white;
  font-family: Poppins;
  font-weight: 600;
  font-size: 20px;
  line-height: 24px;
  letter-spacing: -0.5px;
  vertical-align: middle;
}

.our-school-age-text {
  color: #ffffff;
  font-family: Poppins;
  font-weight: 400;
  font-size: 16px;
  line-height: 22px;
  letter-spacing: 0px;
  color: white;
}
</style>
